var BlockStd = Object.getPrototypeOf(app).BlockStd = new Component("block-std");
BlockStd.debug = false;
BlockStd.createdAt      = "1.0.0";
BlockStd.lastUpdate     = "1.3.7";
BlockStd.version        = "1";



// WEBPACK FOOTER //
// ./src/components/block-std/block-std.js